/**
 * Wraps all non-logged in User components in a default view wrapper
 */

// import primary libraries
import React from 'react';
// import PropTypes from 'prop-types';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class UserLoginLayout extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="master-layout">
        <div className="body ">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default UserLoginLayout;



// WEBPACK FOOTER //
// modules/user/components/UserLoginLayout.js.jsx